(() => {
  const script = document.currentScript;
  if (!(script instanceof HTMLScriptElement)) return;

  const pageType = script.dataset.gtmPage || '';
  const linkSelector = [
    '.se-home-blog__readall[href]',
    'a[class^="hotspot-button-"][href]',
    'a[class*=" hotspot-button-"][href]',
    'a[class^="guarantee-button-"][href]',
    'a[class*=" guarantee-button-"][href]',
  ].join(',');

  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim();

  const getSectionId = (link) => {
    const section = link.closest('[id^="shopify-section-"]');
    return section ? section.id.replace(/^shopify-section-/, '') : '';
  };

  const getTrackingId = (link, sectionId) => {
    const className = typeof link.className === 'string' ? link.className : '';
    const blockMatch = className.match(/(?:hotspot|guarantee)-button-([^\s]+)/);
    if (blockMatch) return blockMatch[1];
    return sectionId ? `${sectionId}-read-all` : 'homepage-blog-read-all';
  };

  const applyTracking = (scope = document) => {
    scope.querySelectorAll(linkSelector).forEach((link) => {
      if (!(link instanceof HTMLAnchorElement) || link.dataset.gtm) return;

      const sectionId = getSectionId(link);
      const name = normalizeText(link.textContent || '');

      link.dataset.gtm = 'cta';
      if (pageType) link.dataset.gtmPage = pageType;
      if (sectionId) link.dataset.gtmSection = sectionId;
      if (name) link.dataset.gtmName = name;
      link.dataset.gtmId = getTrackingId(link, sectionId);
      link.dataset.gtmUrl = link.getAttribute('href') || '';
    });
  };

  applyTracking();
  document.addEventListener('shopify:section:load', (event) => applyTracking(event.target));
})();
